import { Typography } from 'antd';

export const NoneditableLineManagerComment = ({ comment }) => {
  return (
    <Typography.Paragraph style={{ textAlign: 'center' }}>
      <strong>Line manager Comments:</strong> {comment || '-----'}
    </Typography.Paragraph>
  );
};
